export default {
  PLAY: 'play',
  PAUSE: 'pause',
  TIME_UPDATE: 'timeupdate',
  SEEKING: 'seeking',
  SEEKED: 'seeked',
  CAUGHT_UP: 'custom.caughtup',
};
